import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const SupportBoardChat: React.FC = () => {
  const location = useLocation();
  const visibleRoutes = ['/account/help'];
  const shouldShowChat = visibleRoutes.includes(location.pathname);
  const scriptId = 'chat-init';

  useEffect(() => {
    if (shouldShowChat) {
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://cloud.board.support/account/js/init.js?id=1187900647';
        script.async = true;
        script.defer = true;

        // Use requestIdleCallback to load script during idle time
        if ('requestIdleCallback' in window) {
          (window as any).requestIdleCallback(() => document.body.appendChild(script));
        } else {
          // Fallback for older browsers
          setTimeout(() => document.body.appendChild(script), 200);
        }
      }
    }

    return () => {
      // Remove script
      const script = document.getElementById(scriptId);
      script?.remove();

      // Remove all SupportBoard DOM elements (robust cleanup)
      const selectors = [
        '.sb-main.sb-chat',
        '.sb-container',
        '.sb-launcher',
        'iframe[src*="board.support"]',
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          el.remove();
        });
      });
    };
  }, [shouldShowChat]);

  return null;
};
